import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON, isOk, authReq } from '../utils/request';
import isLoggedIn from '../utils/auth';


/******************************
*******  Synchronous  *********
******************************/

export function setDiamondFilters(filters) {
  return {
    type: constants.DIAMONDS_FILTER_SAVE,
    filters
  };
}

export function diamondsSave(diamonds, count = 0) {
	return {
    type: constants.DIAMONDS_SAVE,
    diamonds,
    count,
  };
}

export function diamondsSaveSelected(diamonds) {
	return {
    type: constants.DIAMONDS_SAVE_SELECTED,
    diamonds,
  };
}

export function diamondsSetLastPosition(scrollPos) {
	return {
    type: constants.DIAMONDS_SET_LAST_POSITION,
    scrollPos,
  };
}

export function diamondsToggleListView() {
	return {
    type: constants.DIAMONDS_TOGGLE_LIST,
  };
}

export function setDiamondSource(code) {
  return {
    type: constants.DIAMONDS_SET_SOURCE,
    code
  };
}


/******************************
*******  Asynchronous  ********
******************************/




export function fetchDiamonds(diamondFilters, page) {

	return dispatch => {

		let first = true;
		let getParams = '';

		let pageFilters = Object.assign({}, diamondFilters, {page: page});

		let filterKeys = Object.keys(pageFilters);
		for(let i = 0; i < filterKeys.length; i++) {

			if(first) {
				getParams = '?' + filterKeys[i] + '=' + pageFilters[filterKeys[i]];
			} else {
				getParams += '&' + filterKeys[i] + '=' + pageFilters[filterKeys[i]];
			}
			first = false;
		}
		let encodedParams = encodeURI(getParams);

		let url = api.API_URL + endpoint.DIAMONDS_FETCH + encodedParams;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {

	    	if(resp.status === 201) {
	    		return Promise.resolve(null);
	    	} else {
	    		return Promise.resolve(resp.data);
	    	}
	    	
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function fetchOnlineDiamonds(diamondFilters, page) {

	return dispatch => {

		let first = true;
		let getParams = '';

		let pageFilters = Object.assign({}, diamondFilters, {page: page, sc: 'true'});

		let filterKeys = Object.keys(pageFilters);
		for(let i = 0; i < filterKeys.length; i++) {

			if(first) {
				getParams = '?' + filterKeys[i] + '=' + pageFilters[filterKeys[i]];
			} else {
				getParams += '&' + filterKeys[i] + '=' + pageFilters[filterKeys[i]];
			}
			first = false;
		}
		let encodedParams = encodeURI(getParams);

		let url = api.API_URL + endpoint.ONLINE_DIAMONDS + encodedParams;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {

	    	if(resp.status === 201) {
	    		return Promise.resolve(null);
	    	} else {
	    		return Promise.resolve(resp.data);
	    	}
	    	
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function fetchRapnetDiamonds(diamondFilters, page = 1) {

	return dispatch => {

		let pageFilters = Object.assign({}, diamondFilters, { 
			page_number: page, 
			page_size: 50 
		});

		let url = api.API_URL + endpoint.ONLINE_RAPNET_DIAMONDS;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(pageFilters),
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status) && resp.data.response && resp.data.response.header && resp.data.response.header.error_code === 0) {
	    	return Promise.resolve(resp.data.response.body);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function fetchLocationData(diamondFilters) {

	return dispatch => {

		let first = true;
		let getParams = '';

		let filterKeys = Object.keys(diamondFilters);
		for(let i = 0; i < filterKeys.length; i++) {

			if(first) {
				getParams = '?' + filterKeys[i] + '=' + diamondFilters[filterKeys[i]];
			} else {
				getParams += '&' + filterKeys[i] + '=' + diamondFilters[filterKeys[i]];
			}
			first = false;
		}
		let encodedParams = encodeURI(getParams);

		let headerParams = api.HEADERS;
		if(isLoggedIn()) {
			headerParams = authReq(api.HEADERS)
		}

		let url = api.API_URL + endpoint.DIAMONDS_LOCATION_DATA + encodedParams;
		return fetch(url, {
		  method: 'get',
		  headers: headerParams,
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function fetchSingleDiamond(diamondId) {

	return dispatch => {
		let url = api.API_URL + endpoint.DIAMONDS_FETCH_SINGLE + '?diamond_id=' + diamondId;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function fetchSingleRapnetDiamond(diamondId) {

	return dispatch => {
		let url = api.API_URL + endpoint.ONLINE_RAPNET_DIAMOND_BY_ID;

		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify({ diamond_id: diamondId })
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status) && resp.data.response && resp.data.response.header && resp.data.response.header.error_code === 0) {
	    	return Promise.resolve(resp.data.response.body);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function fetchDiamondManifest(giaNumber) {

	return dispatch => {
		let url = 'https://s3.amazonaws.com/inv-app-diamond-assets-processed-prod/' + giaNumber + '/manifest.json';
		return fetch(url, {
		  method: 'get',
		  headers: api.HEADERS
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}



export function fetchRapnetPrice(diamondObj) {

	return dispatch => {
		let url = api.API_URL + endpoint.ONLINE_RAPNET_PRICE;

		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(diamondObj)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status) && resp.data.response && resp.data.response.header && resp.data.response.header.error_code === 0) {
	    	return Promise.resolve(resp.data.response.body);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}







